import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-step-three-mautic',
  templateUrl: './step-three-mautic.component.html',
  styleUrls: ['./step-three-mautic.component.scss']
})
export class StepThreeMauticComponent implements OnInit {

  @ViewChild('form', { static: false }) form: ElementRef<any>;
  formData: any;

  constructor(
    router: ActivatedRoute,
    @Inject('FORM_API_URL') public formApiUrl: string
  ) { 

    router.queryParams.subscribe(
      query => {
          this.formData = query;
          setTimeout(() => this.form.nativeElement.submit(), 500);
      }
    )

  }

  ngOnInit(): void {
  }

}
